var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutLandingArrowB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 477,
    height: 141,
    viewBox: "0 0 477 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49672 138.8C2.49672 138.8 163.997 -45.5538 475.497 12.9583M2.49672 138.8C-0.289407 136.802 3.49773 114.135 3.49773 114.135M2.49672 138.8C5.29164 140.803 21.5761 137.793 24.998 137.296",
    stroke: "#6F71EE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutLandingArrowB);
export default __webpack_public_path__ + "static/media/aboutLandingArrowB.b21da6569a9b0880ea68431d57f4b164.svg";
export { ForwardRef as ReactComponent };